import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { MenuNotifier } from './menu-notifier';
import { MenuState } from './menu-state';

@Injectable()
export class MenuProvider extends BaseProvider<MenuNotifier, MenuState> {
  constructor() {
    super(MenuNotifier);
  }
}
